import React from 'react';
import ConfirmActionModal from '../../components/ConfirmActionModal';
import type { ActionModalProps } from '../../constants';
import useTrackEvent from '~/hooks/useTrackEvent';

export type Props = {
  dataTestId?: string;
} & ActionModalProps;

const SendToContaqt: React.FCC<Props> = ({
  onCancel,
  onComplete,
  selectedContactAmount,
  ...rest
}) => {
  const trackEvent = useTrackEvent();

  return (
    <ConfirmActionModal
      selectedContactAmount={selectedContactAmount}
      actionType="SendToContaqt"
      actionInput={{
        SendToContaqt: {},
      }}
      onComplete={() => {
        /** ----- TRACKING: contacts_sent_to_contaqt ----- */
        trackEvent({
          eventName: 'contacts_sent_to_contaqt',
          parameters: {
            contacts_amount: selectedContactAmount,
          },
        });
        onComplete();
      }}
      onCancel={onCancel}
      {...rest}
    />
  );
};

export default SendToContaqt;
